import { render, staticRenderFns } from "./EducationPostsDialog.vue?vue&type=template&id=02c74102"
import script from "./EducationPostsDialog.vue?vue&type=script&lang=js"
export * from "./EducationPostsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports